import axios from "axios";
import { FETCH_CORRESPONSALES_FAILURE, FETCH_CORRESPONSALES_SUCCESS } from "./types";
import { PATH } from "../../utils";

const SESSION_EXPIRED = "SESSION_EXPIRED";
const API_BASE = `${PATH}`;

const apiServiceGet = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const apiServicePost = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handle401 = (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenadmin");
  if (dispatch) dispatch({ type: SESSION_EXPIRED });
};

const fetchCorresponsalesSuccess = (payload) => ({
  type: FETCH_CORRESPONSALES_SUCCESS,
  payload,
});

const fetchCorresponsalesFailure = (message) => ({
  type: FETCH_CORRESPONSALES_FAILURE,
  payload: { error: message },
});

const buildBody = ({ q, search, include_inactive } = {}) => {
  const body = {};
  const term = (q != null ? String(q) : "") || (search != null ? String(search) : "");
  const t = String(term || "").trim();
  if (t) body.q = t;
  if (include_inactive != null) body.include_inactive = !!include_inactive;
  return body;
};

export const actionCorresponsalesGet = (params = {}) => {
  return async (dispatch) => {
    try {
      const resp = await apiServiceGet.get("corresponsales", {
        params,
        headers: { ...authHeader() },
      });
      dispatch(fetchCorresponsalesSuccess(resp.data));
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      const msg = error?.response?.data?.detail || error.message || "Error al cargar corresponsales";
      dispatch(fetchCorresponsalesFailure(msg));
      throw error;
    }
  };
};

export const actionCorresponsalesCard = (params = {}) => {
  return async (dispatch) => {
    try {
      const body = buildBody(params);
      const resp = await apiServicePost.post("corresponsales/cards", body, {
        headers: { ...authHeader() },
      });
      dispatch(fetchCorresponsalesSuccess(resp.data));
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      const msg = error?.response?.data?.detail || error.message || "Error al cargar corresponsales";
      dispatch(fetchCorresponsalesFailure(msg));
      throw error;
    }
  };
};

export const actionCorresponsalCreate = (payload, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      const resp = await apiServicePost.post("corresponsales", payload, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorresponsalesGet({}));
      onDone(resp.data);
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      const msg = error?.response?.data?.detail || error.message || "No se pudo crear el corresponsal";
      dispatch(fetchCorresponsalesFailure(msg));
      throw error;
    }
  };
};

export const actionCorresponsalGetById = (id_corresponsal) => {
  return async () => {
    const resp = await apiServiceGet.get(`corresponsales/${id_corresponsal}`, {
      headers: { ...authHeader() },
    });
    return resp.data;
  };
};

export const actionCorresponsalUpdate = (id_corresponsal, payload, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      const resp = await apiServicePost.patch(`corresponsales/${id_corresponsal}`, payload, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorresponsalesGet({}));
      onDone(resp.data);
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      const msg = error?.response?.data?.detail || error.message || "No se pudo actualizar el corresponsal";
      dispatch(fetchCorresponsalesFailure(msg));
      throw error;
    }
  };
};

export const actionCorresponsalUpdateById = (id_corresponsal, payload, onDone = () => {}) => {
  return actionCorresponsalUpdate(id_corresponsal, payload, onDone);
};

export const actionCorresponsalDelete = (id_corresponsal, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      const resp = await apiServiceGet.delete(`corresponsales/${id_corresponsal}`, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorresponsalesGet({}));
      onDone(resp.data);
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      const msg = error?.response?.data?.detail || error.message || "No se pudo eliminar el corresponsal";
      dispatch(fetchCorresponsalesFailure(msg));
      throw error;
    }
  };
};
